import LuxPlusLabelWithModal from 'luxPlus/components/LuxPlusLabelWithModal'
import { useCurrentSiteTakeover } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import { LUX_PLUS_MONTH_TAKEOVER_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'
import LuxPlusMonthLabel from 'takeovers/luxPlusMonthTakeover/components/LuxPlusMonthLabel'

interface Props {
  luxPlusInclusions: Array<App.PackageInclusion>
  offer?: App.CruiseOffer
  isModalPrimaryActionHidden?: boolean
}

function CruiseLuxPlusOnboardCreditLabel(props: Props) {
  const { luxPlusInclusions, offer, isModalPrimaryActionHidden } = props
  const firstLuxPlusInclusion = luxPlusInclusions[0]

  const isLPMonthTakeoverEnabled = useCurrentSiteTakeover({ offer })?.id === LUX_PLUS_MONTH_TAKEOVER_ID

  return <>
    {!!firstLuxPlusInclusion && !isLPMonthTakeoverEnabled && <LuxPlusLabelWithModal
      type="bonus-inclusions"
      inclusionDescription={firstLuxPlusInclusion.description}
      inclusions={luxPlusInclusions}
      offer={offer}
      isModalPrimaryActionHidden={isModalPrimaryActionHidden}
    />}
    {!!firstLuxPlusInclusion && isLPMonthTakeoverEnabled && <LuxPlusMonthLabel
      type="bonus-inclusions"
      description={firstLuxPlusInclusion.description}
    />}
  </>
}

export default CruiseLuxPlusOnboardCreditLabel
